/*
    Resizes an image to a specific size while keeping the aspect ration and cropping it
    from the center.
*/
export default (file, width = 300, height = 300) => {
    return new Promise(resolve => {
        const fileReader = new FileReader();

        fileReader.onload = event => {
            const image = new Image();
            const canvasElement = document.createElement("canvas");
            const ctx = canvasElement.getContext("2d");
            ctx.fillStyle = "white";
            ctx.fillRect(0, 0, width, height);

            image.onload = () => {
                // resize
                let x = 0,
                    y = 0,
                    aspectRadio,
                    adjustedImageWidth,
                    adjustedImageHeight;

                aspectRadio = image.naturalHeight / image.naturalWidth;

                // retain aspect ratio
                if (image.naturalHeight < image.naturalWidth) {
                    // horizontal
                    aspectRadio = image.naturalWidth / image.naturalHeight;
                    (adjustedImageHeight = height), (adjustedImageWidth = aspectRadio * height);
                    x = -(adjustedImageWidth - width) / 2;
                } else {
                    // vertical
                    (adjustedImageWidth = width), (adjustedImageHeight = aspectRadio * width);
                    y = -(adjustedImageHeight - height) / 2;
                }

                canvasElement.width = adjustedImageWidth;
                canvasElement.height = adjustedImageHeight;
                ctx.drawImage(image, x, y, adjustedImageWidth, adjustedImageHeight);

                const imageToCrop = new Image();

                imageToCrop.onload = () => {
                    canvasElement.width = width;
                    canvasElement.height = height;

                    // crop
                    ctx.drawImage(
                        imageToCrop,
                        imageToCrop.naturalWidth / 2 - width / 2,
                        imageToCrop.naturalHeight / 2 - height / 2,
                        width,
                        height,
                        0,
                        0,
                        width,
                        height,
                    );

                    canvasElement.toBlob(
                        blob => {
                            resolve(blob);
                        },
                        "image/jpeg",
                        1,
                    );
                };

                imageToCrop.src = canvasElement.toDataURL("image/jpeg", 1);
            };

            image.src = event.target.result;
        };

        fileReader.readAsDataURL(file);
    });
};
